import React from "react";

import { useTranslation } from "react-i18next";
import { useTracking } from "@local-logic/core/tracking";

import { ListIcon } from "@phosphor-icons/react";
import { Button } from "@local-logic/design-system";

import {
  TrackingPipelineEvents,
  AnalyticsEvents,
} from "~/sdks/LocalContent/types";

import { useRootElement } from "../context";

import * as styles from "./styles";

export function Toggle() {
  const { t } = useTranslation("localContent");
  const tracking = useTracking();
  const { isExpanded, onToggleIsExpanded } = useRootElement();

  const handleOnClick = () => {
    const eventAttributes = {
      currentIsExpanded: isExpanded,
    };

    tracking.postEvent({
      eventType: TrackingPipelineEvents.CATEGORIES_MENU_TOGGLE_CLICKED,
      eventAttributes: Object.entries(eventAttributes).map(([key, value]) => ({
        label: key,
        data: value,
      })),
    });

    tracking.trackAnalyticsEvent({
      eventName: AnalyticsEvents.CATEGORIES_MENU_TOGGLE_CLICKED,
      eventAttributes,
    });

    onToggleIsExpanded();
  };

  return (
    <Button
      className={styles.container}
      prefixIcon={<ListIcon className={styles.icon} />}
      onClick={handleOnClick}
      data-testid="categories-toggle-button"
      data-is-expanded={isExpanded}
    >
      {t("categoriesToggle.toggleLabel")}
    </Button>
  );
}
